import Routes from "routing/Routes";
import DefaultBrand from "./DefaultBrand";
const perspectivesBindings = {
  perspectives: [
    {
      id: "default",
      title: "General",
      welcomeRoute: Routes.WELCOME,
      brandComponent: DefaultBrand
    }
  ]
};
export default perspectivesBindings;
